import { useEffect, useState } from "react";
import { replaceUrl } from "@/lib/replaceUrl";

// Mirrors useState for one query param, so a copied link or a bookmark opens
// the page as it was. `parse` turns the param (null when missing) into a
// value; `format` turns a value back into the param, null for the default so
// the link stays short. Replaces the history entry, so Back leaves the page.
export function useUrlParam<T>(
  name: string,
  parse: (raw: string | null) => T,
  format: (value: T) => string | null,
): [T, (next: T) => void] {
  const [value, setValue] = useState<T>(() =>
    parse(typeof window === "undefined" ? null : new URLSearchParams(window.location.search).get(name)),
  );
  const param = format(value);

  useEffect(() => {
    const url = new URL(window.location.href);
    if (url.searchParams.get(name) === param) return;
    if (param === null) url.searchParams.delete(name);
    else url.searchParams.set(name, param);
    replaceUrl(url);
  }, [name, param]);

  return [value, setValue];
}
